// Turns a phone number into E.164 for Dialpad. US numbers only, except
// numbers that already start with + are trusted as-is. Returns null when the
// number can't be dialed.
export function toE164(phone) {
  if (!phone) {
    return null;
  }

  const raw = String(phone).trim();
  const digits = raw.replace(/\D/g, '');

  if (raw.startsWith('+')) {
    return digits.length >= 8 && digits.length <= 15 ? `+${digits}` : null;
  }

  if (digits.length === 10) {
    return `+1${digits}`;
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }

  return null;
}
